import { useState } from "react";
import { COOKIE_CATEGORIES } from "../hooks/useCookies.js";

export default function CookieSettings({ consent, onClose, onAcceptAll, onRejectAll, onSave }) {
  const [prefs, setPrefs] = useState({
    necessary: true,
    analytics: consent.analytics || false,
    marketing: consent.marketing || false,
  });

  const toggle = (key) => {
    if (key === "necessary") return;
    setPrefs((current) => ({ ...current, [key]: !current[key] }));
  };

  return (
    <div className="wc-modal-overlay" onClick={(event) => event.target === event.currentTarget && onClose()}>
      <div className="wc-modal" role="dialog" aria-label="Preferencias de cookies">
        <div className="wc-modal-header">
          <div className="wc-cookie-brand">
            <div className="wc-cookie-logo" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="2" />
                <circle cx="10" cy="11" r="2" fill="currentColor" />
                <circle cx="18" cy="11" r="2" fill="currentColor" />
                <circle cx="14" cy="18" r="2" fill="currentColor" />
                <path d="M7 7C7 7 9 5 14 5C19 5 21 7 21 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <div className="wc-cookie-title">WeltasCorp Cookie</div>
              <div className="wc-cookie-subtitle">Preferencias de privacidad</div>
            </div>
          </div>
          <button className="wc-modal-close" onClick={onClose} aria-label="Cerrar">x</button>
        </div>

        <div className="wc-modal-body">
          {Object.values(COOKIE_CATEGORIES).map((category) => (
            <div className="wc-cat-row" key={category.id}>
              <div className="wc-cat-info">
                <div className="wc-cat-label">{category.label}</div>
                <div className="wc-cat-desc">{category.description}</div>
              </div>
              <label className="wc-switch">
                <input
                  type="checkbox"
                  checked={prefs[category.id]}
                  onChange={() => toggle(category.id)}
                  disabled={category.id === "necessary"}
                />
                <span className="wc-slider"></span>
              </label>
            </div>
          ))}
        </div>

        <div className="wc-modal-footer">
          <button className="wc-btn wc-btn-ghost" onClick={onRejectAll}>
            Rechazar opcionales
          </button>
          <button className="wc-btn wc-btn-ghost" onClick={onAcceptAll}>
            Aceptar todas
          </button>
          <button className="wc-btn wc-btn-primary" onClick={() => onSave(prefs)}>
            Guardar preferencias
          </button>
        </div>
      </div>
    </div>
  );
}
